import { Env } from 'types/env/Env.type';

export const getCurrentAuthMethod = (env: Env) => {
  return {
    isUsingGateway: env.auth.method === 'gateway',
    isUsingWebseal: env.auth.method === 'webseal',
    isUsingIbmGrant: env.auth.method === 'ibmGrant',
    isUsingAfSso: env.auth.method === 'client'
  };
};
